// export const isExtractDataUngated = process.env.VUE_APP_ENVIRONMENT !== 'prod';
export const isExtractDataUngated = true;
export const isCompareDocsUngated = process.env.VUE_APP_ENVIRONMENT !== 'prod';
export const isCompareLabelsUngated =
  process.env.VUE_APP_ENVIRONMENT !== 'prod';
export const isTimelinesUngated = process.env.VUE_APP_ENVIRONMENT !== 'prod';
export const isProductTablesUngated =
  process.env.VUE_APP_ENVIRONMENT !== 'prod';
export const isSuggestFiltersUngated =
  process.env.VUE_APP_ENVIRONMENT !== 'prod';
export const isNotificationPrefsUngated =
  process.env.VUE_APP_ENVIRONMENT !== 'prod';
